import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { SwitchableVersionProjectItemEntity } from './switchable-version-project-item.entity';
import {
	ISwitchableVersionProjectListExtra,
	SwitchableVersionProjectListEntity,
} from './switchable-version-project-list.entity';

@Injectable()
export class SwitchableVersionProjectListProvider {
	private switchableVersionProjectList!: SwitchableVersionProjectListEntity;

	public constructor() {}

	public getColumnsWithoutSubscription(): Array<ISwitchableVersionProjectListExtra> {
		return [
			{
				field: 'consumerProjectLabel',
				alias: $localize`:i18n=@@subscription.versionSwitcher.project.list.column.consumerProjectLabel:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 0,
			},
			{
				field: 'consumerProjectVersion',
				alias: $localize`:i18n=@@subscription.versionSwitcher.project.list.column.consumerProjectVersion:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 1,
			},
			{
				field: 'profileLabel',
				alias: $localize`:i18n=@@subscription.versionSwitcher.project.list.column.profileLabel:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 2,
			},
			{
				field: 'currentProducerVersion',
				alias: $localize`:i18n=@@subscription.versionSwitcher.project.list.column.currentProducerVersion:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 3,
			},
			{
				field: 'blockedReason',
				alias: $localize`:i18n=@@subscription.versionSwitcher.project.list.column.blockedReason:`,
				type: 'string',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				canBeReordered: false,
				visibleIndex: 4,
			},
		];
	}

	public getColumnsWithSubscription(): Array<ISwitchableVersionProjectListExtra> {
		return [
			{
				field: 'subscriptionLabel',
				alias: $localize`:i18n=@@subscription.versionSwitcher.project.list.column.subscriptionLabel:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: true,
				visibleIndex: 0,
			},
			...this.getColumnsWithoutSubscription().map((column, index) => ({
				...column,
				visibleIndex: column.visibleIndex ? column.visibleIndex + 1 : index + 1,
			})),
		];
	}

	public createAvailableColumnsWithSubscription(): void {
		const columns = this.getColumnsWithSubscription();
		this.switchableVersionProjectList =
			SwitchableVersionProjectListEntity.build(columns);
	}

	public createAvailableColumnsWithoutSubscription(): void {
		const columns = this.getColumnsWithoutSubscription();
		this.switchableVersionProjectList =
			SwitchableVersionProjectListEntity.build(columns);
	}

	public getList(): SwitchableVersionProjectListEntity {
		return this.switchableVersionProjectList;
	}

	public setListElements(
		elements: Map<string, SwitchableVersionProjectItemEntity>
	): SwitchableVersionProjectListEntity {
		return this.switchableVersionProjectList.setElements(elements);
	}
}
